module.exports = __webpack_public_path__ + "img/drmartens_sinclair.3c39515d.png";